<template>
  <div class="appLayOut" id="appLayOut">
    <Header ref="header" v-if="!getCurrentRouteName()"/>
    <main class="main">
      <div class="routerView" :style="viewStyle">
        <transition name="fade" mode="out-in">
          <router-view></router-view>
        </transition>
      </div>
      <Footer ref="footer" v-if="!getCurrentRouteName"/>
    </main>
  </div>
</template>
<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import {useFitScreen} from '@/utils/useFitScreen'

export default {
  // 组件名字
  name: "App",
  // 状态数据
  data() {
    return {
      viewStyle: {
        'min-height': 'auto'
      },
      hidden: ['/participating', '/registration']
    };
  },
  components: {
    Header,
    Footer,
  },
  mounted() {
    useFitScreen('#appLayOut')
    this.updateViewportHeight(); // 组件加载后获取可视区域高度
    window.addEventListener('resize', this.updateViewportHeight);
  },
  methods: {
    updateViewportHeight() {
      this.$nextTick(() => {
        this.getViewportHeight()
      })
    },
    getViewportHeight() {
      const headerElement = this.$refs.header.$el;
      const height = headerElement.offsetHeight - 220
      this.viewStyle['min-height'] = `calc(100vh - ${height}px)`
    }
  },
  computed: {
    getCurrentRouteName() {
      return function () {
        return this.$route?.meta?.layout === 'hidden' || false
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateViewportHeight); // 销毁时移除事件监听器
  }
};
</script>
<style lang="less">
* {
  margin: 0;
  padding: 0;
}

.appLayOut {
  width: 100%;
  height: 100vh;
  display: flex;
  overflow: auto;
  flex-direction: column;

  .main {
    flex: 1;
    height: 100%;
    //overflow: auto;

    .routerView {
      min-height: 650px;
      background-color: #f2f8ff;
    }
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

:deep(.no-scroll) {
  overflow: hidden !important;
}
</style>
